import React from "react";
import { Facebook, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-14 px-6 md:px-20">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* COLUMN 1 - Brand */}
        <div>
          <h2 className="text-2xl font-bold text-white mb-4">
            The Kaizen Business Solutions
          </h2>
          <p className="text-sm leading-relaxed">
            Providing modern technology solutions, digital transformation, and
            branding strategies to help businesses grow, innovate, and optimize
            their performance.
          </p>

          <div className="flex gap-4 mt-5">
            <a href="/" className="hover:text-white transition">
              <Facebook size={20} />
            </a>
            <a href="/" className="hover:text-white transition">
              <Instagram size={20} />
            </a>
            <a href="/" className="hover:text-white transition">
              <Linkedin size={20} />
            </a>
          </div>
        </div>

        {/* COLUMN 2 - Quick Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">
            Quick Links
          </h3>
          <ul className="space-y-3">
            <li><a href="/" className="hover:text-white transition">Home</a></li>
            <li><a href="/services" className="hover:text-white transition">Services</a></li>
            <li><a href="/about" className="hover:text-white transition">About Us</a></li>
            <li><a href="/testimonials" className="hover:text-white transition">Testimonials</a></li>
            <li><a href="/contact" className="hover:text-white transition">Contact</a></li>
          </ul>
        </div>

        {/* COLUMN 3 - Services */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Our Services</h3>
          <ul className="space-y-3">
            <li><a href="/" className="hover:text-white transition">Web Development</a></li>
            <li><a href="/" className="hover:text-white transition">Branding & Design</a></li>
            <li><a href="/" className="hover:text-white transition">Digital Marketing</a></li>
            <li><a href="/" className="hover:text-white transition">Social Media Management</a></li>
            <li><a href="/" className="hover:text-white transition">Custom SaaS Solutions</a></li>
          </ul>
        </div>

        {/* COLUMN 4 - Contact */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-4">Contact Us</h3>
          <ul className="space-y-4 text-sm">

            <li className="flex items-start gap-3">
              <Phone size={18} className="mt-1" />
              <span>+1 (555) 123-4567</span>
            </li>

            <li className="flex items-start gap-3">
              <Mail size={18} className="mt-1" />
              <span>info@thekaizen.ca</span>
            </li>

            <li className="flex items-start gap-3">
              <MapPin size={18} className="mt-1" />
              <span>British Columbia, Canada</span>
            </li>

          </ul>
        </div>
      </div>

      <div className="border-t border-gray-700 mt-12 pt-6 text-center text-sm">
        © {new Date().getFullYear()} The Kaizen Business Solutions. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
